import {FlowModule} from '@fantasmagames/slot/src/modules/flow/FlowModule';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {Action} from '@fantasmagames/slot/src/logic/Action';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';
import {FlowWinningState} from '@fantasmagames/slot/src/modules/flow/states/FlowWinningState';

export class FlowBasicState extends FlowWinningState {
	public onEnterState(): void {
		if (this.shouldFinishFreeSpins()) {
			this.emit(FlowModuleEvents.FREE_SPINS_FINISHED);
		}
	}

	public shouldFinishFreeSpins(): boolean {
		return this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft === 0;
	}

	public handle(id: string, data?: any): void {
		super.handle(id, data);

		this._queueEvents.handleWaitingList(id, data);
	}

	protected setupEvents(): void {
		this.on(ReelsEvents.SPIN_ENDED, this.onAllReelsStopped);
		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
	}

	protected onSpinStarted(): void {
		this._queueEvents.clearEventsQueue();
	}

	protected onAllReelsStopped(): void {
		this._queueEvents.clearEventsQueue();

		if (this.hasAnyBeforeWinFeatures()) {
			this.addBeforeWinFeatures();
		} else {
			this.decideOnNextAction();
		}
	}

	protected decideOnNextAction(): void {
		switch (this.module.logic.nextAction) {
			case Action.SPIN: {
				this.setupNextStateSpinFlow();
				break;
			}

			case Action.FREESPIN: {
				this.handleNextActionFreeSpin();
				break;
			}

			case Action.PICK: {
				this.setupNextStateBonusGameFlow();
				break;
			}

			case Action.AVALANCHE: {
				this.setupNextStateAvalancheFlow();
				break;
			}

			case Action.RESPIN: {
				this.setupNextStateRespin();
				break;
			}

			case Action.EXPLOSION: {
				this.setupExplosionNextState();
				break;
			}

			default:
				this.setupOtherActions(this.module.logic.nextAction);
				break;
		}
	}

	protected setupOtherActions(nextAction: string): void {

	}

	protected setupNextStateRespin(): void {
		this.emitDelayed(FlowModuleEvents.RESPIN_WON);
		this.module.gotoState(FlowModule.RESPIN_STATE);
	}

	protected handleNextActionFreeSpin(): void {
		this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents.FREESPINS_WIN, () => {
			this.module.gotoState(FlowModule.FREE_SPINS_STATE);
		});
		this.setupNextStateFreeSpinsFlow();
	}

	protected setupExplosionNextState(): void {
		throw new Error('FlowBasicState::setupExplosionNextState explosion handling must be implemented');
	}

	protected hasAnyBeforeWinFeatures(): boolean {
		return false;
	}

	protected addBeforeWinFeatures(): void {
	}

	protected setupNextStateSpinFlow(): void {
		if (this.isBigWin()) {
			this.setupBigWin();
		} else if (this.isSpinWin()) {
			this.setupWin();
		} else {
			this.setupNoWin();
		}
	}

	protected setupNextStateFreeSpinsFlow(): void {
		if (this.isSpinWin()) {
			if (this.isBigWin()) {
				this._queueEvents.addEventToWaitingList(BigWinEvents.FINISHED, FlowModuleEvents.FREESPINS_WIN);
				this.setupBigWinNoIndividualNoSpin();
				this.setupCantSpinBigWin();
			} else {
				this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents.FREESPINS_WIN);
				this.setupCantSpinWin();
			}
		} else {
			this.setupCantSpinNoWin();
			this.emit(FlowModuleEvents.FREESPINS_WIN);
		}
	}

	protected setupNextStateBonusGameFlow(): void {
		this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents.BONUS_GAME_START, () => {
			this.module.gotoState(FlowModule.BONUS_STATE);
		});

		if (this.isBigWin()) {
			this.setupBigWinNoIndividualNoSpin();
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents.BONUS_GAME_WON);
			this._queueEvents.addEventToWaitingList(FlowModuleEvents.BONUS_GAME_WON, FlowModuleEvents.BONUS_GAME_START);
		} else if (this.isSpinWin()) {
			this.setupCantSpinWin();
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents.BONUS_GAME_WON);
			this._queueEvents.addEventToWaitingList(FlowModuleEvents.BONUS_GAME_WON, FlowModuleEvents.BONUS_GAME_START);
		} else {
			this.setupCantSpinNoWin();
			this.emit(FlowModuleEvents.BONUS_GAME_WON);
			if (this.module.logic.hasRestore) {
				this.emit(FlowModuleEvents.BONUS_GAME_RESTORED);
			}
			this.emit(FlowModuleEvents.BONUS_GAME_START);
		}
	}

	protected setupNextStateAvalancheFlow(): void {
		this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents.AVALANCHE_WON, () => {
			this.module.gotoState(FlowModule.AVALANCHE_STATE);
		});
		if (this.isBigWin()) {
			this.setupBigWinNoIndividualNoSpin();
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_STARTED, FlowModuleEvents.AVALANCHE_WON);
		} else if (this.isSpinWin()) {
			this.setupCantSpinWin();
			this._queueEvents.addEventToWaitingList(WinPresentationEvents.INITIAL_ANIMATION_STARTED, FlowModuleEvents.AVALANCHE_WON);
		} else {
			this.emit(FlowModuleEvents.AVALANCHE_WON);
			this.setupCantSpinNoWin();
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/flow/states/FlowBasicState.ts